import * as kea from "kea-react";
import * as React from "react";
import * as models from "app/models/requireme";
import { createSelector } from "keautils";

type Entity = models.DatosBancoRep;
interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
}

export function validar(x: Entity): kea.validation.Result<Entity> {
    const rules: kea.validation.Rules<Entity> = {
         
    };

    return kea.validation.getErrors(rules, x);
}

export class DatosBancoRep extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    errors = createSelector(this.value, x => validar(x));
    getField = kea.formfields(() => this.props, () => this.errors(this.props));

    render() {
        const Text = this.getField(kea.Text);
        return (
            <kea.Panel title="Banco">
                {kea.autogrid(2, [
                    <Text field="NumeroOperacion" label="Num. operación" />,
                    <Text field="RfcEmisorCtaOrd" label="Rfc emisor cta. ord." />,
                    <Text field="RfcEmisorCtaBen" label="Rfc emisor cta. ben." />,
                    
                    <Text field="NomBancoOrdExt" label="Banco ord. ext." />,
                    
                    <Text field="CtaOrdenante" label="Cta. ord." />,
                    <Text field="CtaBeneficiario" label="Cta. ben." />
                ])}
            </kea.Panel>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/facturas/pagos/form/banco.tsx